import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IStore from '@meronex/icons/mdc/MdcWarehouse';
import TopHeader from '../../../views/components/TopHeader';

import { storesMng } from '../../api/storesMng';
import StoreForm from './StoreForm';

function AddStoreDialog(props) {
  const { open, onClose, onAdd } = props;

  const [loading, setLoading] = React.useState(false);
  const [formData, setFormData] = React.useState();

  const createStore = async () => {
    setLoading(true);
    const store = { ...formData };
    delete store.isValid;
    try {
      await storesMng.addStore(store);
      onAdd();
      _onClose();
      toast.success('Store created successfully', {
        autoClose: 900,
      });
    } catch (e) {
      toast.error('Ops, something went wrong');
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const _onClose = () => {
    setFormData({});
    onClose();
  };

  if (!open) {
    return null;
  }
  return (
    <Dialog
      className={'fullScreenMobile'}
      open={open}
      onClose={_onClose}
      aria-labelledby="responsive-dialog-title">
      <DialogTitle>
        <TopHeader
          title={'Add New Store'}
          onClose={_onClose}
          icon={<IStore size={20} />}
        />
      </DialogTitle>
      <DialogContent>
        {open && (
          <StoreForm
            validateOnInit={false}
            onChange={(data) => {
              setFormData({ ...data });
            }}
            data={formData}
          />
        )}
        <div
          style={{
            marginBottom: '20px',
            marginTop: '10px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={loading}
            disabled={loading || !formData || !formData.isValid}
            label={<span>Create Store</span>}
            onClick={() => {
              createStore();
            }}
            onEnter={() => {
              createStore();
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

AddStoreDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
};

export default AddStoreDialog;
